import {ErrorAction, ReduxAction} from "../../models/common/ActionTypes";
import {AppState} from "../../reducers/RootReducer";
import {  StateObservable, ofType } from "redux-observable";
import { switchMap, map, catchError } from "rxjs/operators";
import {APP_CONFIG} from "../../config/GeneralConfig";
import {currentLanguageFromStore} from "../../config/LanguageConfig";
import {eventNotificationShow} from "../common/EventNotificationActions";
import {EVENT_NOTIFICATION_TYPE} from "../../helpers/EventNotificationType";
import {createErrorResponse} from "../../config/languages/definitions/AjaxResponses";
import { ajax } from "rxjs/ajax";
import { Observable, of } from 'rxjs';
import {UserViewSettings, UserViewSettingsProp } from "../../models/common/ViewSettings";

import {getUrlParamsFromViewSettings} from "../../config/RouteConfig";

import {ApiReturnType} from "../../models/common/ApiReturnType";
import { downloadFileHelper } from "../../helpers/FileHelpers";
import {ProjectReport} from "../../models/reporting/ProjectReport";
import {ProjectReportModule} from "../../models/reporting/ProjectReportModule";
import {ExportTypes} from "../../models/common/Export";
import {FileData} from "../../models/common/FileData";

export type ProjectReportActionTypes = FetchProjectReportActionTypes

export interface FetchProjectReportAction extends UserViewSettingsProp, ReduxAction<typeof FETCH_PROJECT_REPORT > {

}
export interface FetchProjectReportSuccessAction extends ReduxAction<typeof FETCH_PROJECT_REPORT_SUCCESS> {
    reports: ApiReturnType< ProjectReport[] >
}
export interface FetchProjectReportErrorAction extends ErrorAction<typeof FETCH_PROJECT_REPORT_ERROR> {
}

export type FetchProjectReportActionTypes = FetchProjectReportAction
    | FetchProjectReportSuccessAction
    | FetchProjectReportErrorAction


export const FETCH_PROJECT_REPORT = "FETCH_PROJECT_REPORT";
export const FETCH_PROJECT_REPORT_SUCCESS = "FETCH_PROJECT_REPORT_SUCCESS";
export const FETCH_PROJECT_REPORT_ERROR = "FETCH_PROJECT_REPORT_ERROR";

export function fetchProjectReport( userViewSettings: UserViewSettings ): FetchProjectReportAction {
    return { type: FETCH_PROJECT_REPORT, userViewSettings };
}
export function fetchProjectReportSuccess( reports: ApiReturnType< ProjectReport[] > ): FetchProjectReportSuccessAction {
    return { type: FETCH_PROJECT_REPORT_SUCCESS, reports };
}
export function fetchProjectReportError( error: Error ): FetchProjectReportErrorAction {
    return {type: FETCH_PROJECT_REPORT_ERROR, error };
}

export function fetchProjectReportEpic (
    action$: Observable< FetchProjectReportAction >,
    store$: StateObservable< AppState >
) {
    return action$.pipe(
        ofType( FETCH_PROJECT_REPORT ),
        switchMap( action => {
            const settingPath = getUrlParamsFromViewSettings( action.userViewSettings );
            const path = `${ APP_CONFIG.baseWeb }reporting/projects${ settingPath }`;
            const language = currentLanguageFromStore( store$ );

            return ajax( APP_CONFIG.getRequestObject( path ) ).pipe(
                map( response => fetchProjectReportSuccess( response.response as ApiReturnType< ProjectReport[] > ) ),
                catchError( error => of(
                    fetchProjectReportError(error ),
                    eventNotificationShow(
                        EVENT_NOTIFICATION_TYPE.customAjaxError,
                        createErrorResponse(
                            language,
                            error.status,
                            ProjectReportModule.identifier,
                            "fetchProjectReport"
                        )
                    )
                ) )
            )
        })
    );
}


/**
 * export
 */
export interface FetchProjectReportExportAction extends UserViewSettingsProp, ReduxAction<typeof FETCH_PROJECT_REPORT_EXPORT > {
    fileData: FileData
    exportTypes: ExportTypes
}
export interface FetchProjectReportExportSuccessAction extends ReduxAction<typeof FETCH_PROJECT_REPORT_EXPORT_SUCCESS> {
}
export interface FetchProjectReportExportErrorAction extends ErrorAction<typeof FETCH_PROJECT_REPORT_EXPORT_ERROR> {
}

export type FetchProjectReportExportActionTypes = FetchProjectReportExportAction
    | FetchProjectReportExportSuccessAction
    | FetchProjectReportExportErrorAction

export const FETCH_PROJECT_REPORT_EXPORT = "FETCH_PROJECT_REPORT_EXPORT";
export const FETCH_PROJECT_REPORT_EXPORT_SUCCESS = "FETCH_PROJECT_REPORT_EXPORT_SUCCESS";
export const FETCH_PROJECT_REPORT_EXPORT_ERROR = "FETCH_PROJECT_REPORT_EXPORT_ERROR";

export function fetchProjectReportExport(
    exportTypes: ExportTypes,
    userViewSettings: UserViewSettings,
    fileData: FileData
): FetchProjectReportExportAction {
    return {
        type: FETCH_PROJECT_REPORT_EXPORT,
        userViewSettings ,
        exportTypes,
        fileData
    };
}
export function fetchProjectReportExportSuccess(): FetchProjectReportExportSuccessAction {
    return { type: FETCH_PROJECT_REPORT_EXPORT_SUCCESS };
}
export function fetchProjectReportExportError(
    error: Error
): FetchProjectReportExportErrorAction {
    return {type: FETCH_PROJECT_REPORT_EXPORT_ERROR, error };
}

export function fetchProjectReportExportEpic (
    action$: Observable< FetchProjectReportExportAction >,
    store$: StateObservable< AppState >
) {
    return action$.pipe(
        ofType( FETCH_PROJECT_REPORT_EXPORT ),
        switchMap( action => {
            const settingPath = getUrlParamsFromViewSettings( action.userViewSettings );
            const path = `${ APP_CONFIG.baseWeb }reporting/projects/export/${ action.exportTypes }${ settingPath }`;
            const language = currentLanguageFromStore( store$ );

            return ajax({
                ...APP_CONFIG.getRequestObject(path),
                responseType: "blob",
                async: false
            }).pipe(
                map( response => {
                    console.log( response )
                    //@ts-ignore
                    downloadFileHelper( response.response, action.fileData );

                    return fetchProjectReportExportSuccess();
                } ),
                catchError( error => {

                    return of(
                        fetchProjectReportExportError(error),
                        eventNotificationShow(
                            EVENT_NOTIFICATION_TYPE.customAjaxError,
                            createErrorResponse(
                                language,
                                error.status ?? 200,
                                "",
                                "fetchProjectReportExport"
                            )
                        )
                    )
                } )
            )
        })
    );
}